<template>
  <div>
    <PairSpin :show="isShowPairSpin"/>
    <Content class="cust-content">
      <Row class="content-table-wrapper">
        <Row>
          <Table :columns="tableColumns" :data="recordHistDataAuditList" :loading="isListLoading" stripe border />
        </Row>
      </Row>
    </Content>
  </div>
</template>

<script>
import * as Utils from '@/utils'
import SearchWrapper from '@/components/wrapper/SearchWrapper'

export default {
  components: {
    // Title
    SearchWrapper
  },
  props: {
    compId: {
      type: String,
      require: true,
      default: () => {
        return ''
      }
    },
    projId: {
      type: String,
      require: true,
      default: () => {
        return ''
      }
    },
    dataAuditId: {
      type: String,
      require: false,
      default: () => {
        return ''
      }
    },
    // transId: {
    //   type: String,
    //   require: false,
    //   default: () => {
    //     return ''
    //   }
    // },
    // docMth: {
    //   type: Number,
    //   require: false,
    //   default: () => {
    //     return 0
    //   }
    // },
    // docIndex: {
    //   type: Number,
    //   require: false,
    //   default: () => {
    //     return 0
    //   }
    // },
    source: {
      type: String,
      require: true,
      default: () => {
        return 'TRANS' // TRANS-成本栏结算人的凭证明细页面， INVOICE-成本票台账页面
      }
    }
  },
  data() {
    return {
      fixedHeader: true,
      tableHeight: 400,
      isListLoading: false,
      isShowPairSpin: false,
      isDeleteLoading: false,
      parentPath: '',
      parentTitle: '',
      modalCertInfo: false,
      searchInfoSwitch: '0',
      searchFormValidate: {
        // searchType: [
        //   { required: true, message: this.$t('module.proj.projstatistic.searchValidateInfo.searchTypeRequired'), trigger: 'change' }
        // ]
      },
      // baseInfoSwitch: '0',
      // indEditEntity: false,
      entityFormValidate: {
        // entityName: [
        //   { required: true, message: this.$t('module.proj.project.projsettleentity.validateInfo.entityNameRequired'), trigger: 'change' }
        // ],
        // ctrAcctId: [
        //   { required: true, message: this.$t('module.proj.project.projsettleentity.validateInfo.ctrAcctIdRequired'), trigger: 'change' }
        // ],
        // costColId: [
        //   { required: true, message: this.$t('module.proj.project.projsettleentity.validateInfo.costColIdRequired'), trigger: 'change' }
        // ]
      },
      // settleEditIndex: -1,
      // settleEntityName: '',
      listValidate: {
        // transDt: [
        //   { required: true, message: this.$t('module.proj.projsettleinvoice.validateInfo.transDtRequired'), trigger: 'change', pattern: /.+/ }
        // ]
      },
      pStyle: {
        fontSize: '16px',
        color: 'rgba(0,0,0,0.85)',
        lineHeight: '24px',
        display: 'block',
        marginBottom: '16px'
      },
      tableColumns: [
        // {
        //   title: this.$t('module.proj.projsettleinvoice.info.transDt'),
        //   slot: 'transDt',
        //   align: 'center',
        //   width: 110,
        //   fixed: 'left'
        // },
        // {
        //   title: this.$t('module.audit.dataaudit.info.logUid'),
        //   key: 'logUid',
        //   width: 170,
        //   align: 'center',
        //   renderHeader: Utils.renderHeader,
        //   render: (h, params) => {
        //     let logUid = params.row.logUid
        //     let result = (logUid && logUid.length && logUid.length > 12) ? (logUid.substr(0, 6) + '...' + logUid.substr(logUid.length - 6, 6)) : logUid
        //     return [
        //       h('a', {
        //         props: {
        //           href: 'javascript:void(0)'
        //         }
        //       }, [
        //         h('Tooltip', {
        //           props: {
        //             // title: this.$t('common.commonVar.completeInfo'),
        //             content: logUid,
        //             placement: 'top-start',
        //             'max-width': 1000,
        //             transfer: true
        //           }
        //         }, result)
        //       ])
        //     ]
        //   }
        // },
        {
          title: this.$t('module.audit.dataaudit.info.moduleAlias'),
          key: 'tableLabel',
          align: 'center',
          width: 150,
          renderHeader: Utils.renderHeader,
          render: (h, params) => {
            return h('div', {
            }, params.row.tableLabel)
          }
        },
        {
          title: this.$t('module.audit.dataaudit.info.dataAction'),
          key: 'dataAction',
          align: 'center',
          width: 100,
          renderHeader: Utils.renderHeader,
          render: (h, params) => {
            let color = ''
            if (params.row.dataAction === 'INSERT') {
              color = '#19be6b'
            } else if (params.row.dataAction === 'UPDATE') {
              color = '#2db7f5'
            } else if (params.row.dataAction === 'DELETE') {
              color = '#ed4014'
            } else if (params.row.dataAction === 'REMOVE') {
              color = '#ed4014'
            }
            return h('div', {
              style: {
                color: color
              }
            }, this.formatI18nValue('common.commonVar.tableActionList.', params.row.dataAction))
          }
        },
        {
          title: this.$t('module.audit.dataaudit.info.indChanged'),
          key: 'indChanged',
          align: 'center',
          width: 100,
          renderHeader: Utils.renderHeader,
          render: (h, params) => {
            return h('div', {
              style: {
                color: (!(params.row.indChanged === 'Y')) ? '#c5c8ce' : ''
              }
            }, this.formatI18nValue('common.commonVar.indList.', params.row.indChanged))
          }
        },
        {
          title: this.$t('module.audit.dataaudit.info.changeList'),
          key: 'changeList',
          align: 'center',
          renderHeader: Utils.renderHeader,
          render: (h, params) => {
            // if (!params.row.changeList) return ''
            let trList = []
            params.row.changeList.forEach((item, index) => {
              // console.info(item.property)
              // let property = this.$t('module.' + params.row.moduleAlias + '.info.' + item.property) + ':'
              let property = item.propertyLabel || item.property
              // let left = item.leftFormat || item.left // (item.left && Object.keys(item.left).length > 0) ? item.left : ''
              // let right = item.rightFormat || item.right

              let left = (item.leftFormat && Object.keys(item.leftFormat).length > 0) ? item.leftFormat : item.left
              let right = (item.rightFormat && Object.keys(item.rightFormat).length > 0) ? item.rightFormat : item.right
              // let left = item.leftFormat ? item.leftFormat : item.left
              // let right = item.rightFormat ? item.rightFormat : item.right
              let color = ''
              if (params.row.dataAction === 'INSERT') {
                color = '#19be6b'
              } else if (params.row.dataAction === 'UPDATE') {
                color = '#2db7f5'
              } else if (params.row.dataAction === 'DELETE') {
                color = '#ed4014'
              } else if (params.row.dataAction === 'REMOVE') {
                color = '#ed4014'
              }
              trList.push(
                h('tr', {
                }, [
                  h('td', {
                    style: {
                      border: 0,
                      color: color,
                      width: '8%',
                      'text-align': 'left',
                      height: 0
                    }
                  }, '# ' + (index + 1)),
                  h('td', {
                    style: {
                      border: 0,
                      color: color,
                      width: '20%',
                      'text-align': 'right',
                      height: 0
                    }
                  }, property),
                  h('td', {
                    style: {
                      border: 0,
                      color: '#808695',
                      'text-decoration': 'line-through',
                      'text-align': 'right',
                      // width: '20%',
                      height: 0
                    }
                  }, left),
                  h('td', {
                    style: {
                      border: 0,
                      width: '5%',
                      'text-align': 'center',
                      height: 0
                    }
                  }, ' -> '),
                  h('td', {
                    style: {
                      border: 0,
                      color: color,
                      // width: '20%',
                      height: 0
                    }
                  }, right)
                ])
              )
            })
            return h('div', {
            }, [
              h('table', {
                props: {
                  // class: 'xxxx',
                  // 'cellspacing': '0',
                  // cellpadding: 0,
                  // border: 0
                  // stripe: true
                },
                style: {
                  width: '100%',
                  // 'font-weight': 'bold',
                  'border-spacing': 0
                }
              }, trList)
            ])
          }
        },
        {
          title: 'refFieldMap',
          key: 'refFieldMap',
          width: 150,
          align: 'left',
          renderHeader: Utils.renderHeader
        },
        {
          title: this.$t('module.audit.dataaudit.info.userId'),
          key: 'userLegalName',
          width: 90,
          align: 'center',
          renderHeader: Utils.renderHeader
        },
        {
          title: this.$t('module.audit.dataaudit.info.startAndTotalTime'),
          key: 'startAndTotalTime',
          width: 260,
          align: 'center',
          renderHeader: Utils.renderHeader,
          render: (h, params) => {
            let diffTime = ((new Date(params.row.endTime) - new Date(params.row.startTime)) / 1000).toFixed(3)

            return [
              h('span', {
                prop: {
                  type: 'text'
                }
              }, (Utils.formatDateToAll(params.row.startTime))),
              h('span', {
                prop: {
                  type: 'text'
                }
              }, (' / ')),
              h('strong', {
                prop: {
                  type: 'text'
                }
              }, diffTime + 's')
            ]
          }
        }
      ],
      END_DATA: null
    }
  },
  computed: {
    recordHistDataAuditList() {
      return this.$store.state.recordHistDataAuditManage.recordHistDataAuditList
    },
    END_COMPUTED() {
      return null
    }
  },
  methods: {
    formatI18nValue(prefix, value) {
      return value ? this.$t(prefix + value) : null
    },
    initFormValue() {
    },
    cleanForm() {
      this.$store.commit('recordHistDataAuditManage/updateRecordHistDataAuditListEmpty')
    },
    getKeyParam() {
      return { projId: this.projId, compId: this.compId }
    },
    isActiveItem: Utils.isActiveItem,
    // isUsedItem: Utils.isUsedItem,
    formatDate: Utils.formatDate,
    formatDateToDay: Utils.formatDateToDay,
    formatDateToMonth: Utils.formatDateToMonth,
    formatDateToMonthInt: Utils.formatDateToMonthInt,
    formatIntMonth: Utils.formatIntMonth,
    findItemDescrByValue: Utils.findItemDescrByValue,
    // parseDate: Utils.parseDate,
    getMonthFirstDay: Utils.getMonthFirstDay,
    getMonthLastDay: Utils.getMonthLastDay,
    formatThousandthNumber: Utils.formatThousandthNumber,
    parserThousandthNumber: Utils.parserThousandthNumber,
    async refreshList() {
      this.isListLoading = true
      this.$store.commit('recordHistDataAuditManage/updateRecordHistDataAuditListEmpty')
      const result = await this.$store.dispatch('recordHistDataAuditManage/findRecordHistDataAuditList', {...this.getKeyParam(), dataAuditId: this.dataAuditId, ...Utils.getCodeParam(this.$route)})
      if (result.success) {
        this.$store.commit('recordHistDataAuditManage/updateRecordHistDataAuditList', result.data)
      }
      this.isListLoading = false
    },
    async goSearch() {
      this.isShowPairSpin = true
      this.doSearchProcess()
      this.isShowPairSpin = false
    },
    async doSearchProcess() {
      await this.refreshList()
    },
    END_METHODS() {}
  },
  async mounted() {
    // console.info('RecordHistDataAuditCard open')
    // console.info('compId: ', this.compId)
    // console.info('projId: ', this.projId)
    // console.info('id: ', this.id)
    this.cleanForm()
    this.initFormValue()
    await this.goSearch()
  },
  async destroyed() {
    // debugger
    this.cleanForm()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/audit/RecordHistDataAuditCard.vue